import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { faCopy, faDownload, faFileCsv, faFileExcel, faTag, } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';
import {
  deleteShadow,
  duplicateShadow,
  exportShadow,
  selectShadow,
  updateShadow,
} from 'components/shadow_grid/shadows/store/shadows/actions';

import confirm from 'components/confirm';
import Dropdown from 'components/dropdown';
import { RenameModal } from '../rename_modal';

export function ShadowRowActions({
  canExportShadows,
  deleteShadow,
  duplicateShadow,
  exportShadow,
  selectShadow,
  shadow,
  updateShadow
}) {
  const [show, setShow] = useState(false);

  const showDownload = useMemo(() => {
    return canExportShadows && (!shadow.internal || shadow.public);
  }, [canExportShadows, shadow]);

  async function confirmDeletion() {
    try {
      await confirm('Are you sure you want to delete this grid?', {
        buttonLabel: 'Delete',
        buttonStyle: 'danger',
        title: 'Delete Grid',
      });

      deleteShadow(shadow);
    } catch (e) {
      // Nothing to do
    }
  }

  const handleRename = (name) => {
    updateShadow(shadow, { name });
    setShow(false);
  };

  async function handleExport(asCsv) {
    await exportShadow(shadow, asCsv);
  }

  return <>
    <Dropdown>
      <Dropdown.MenuItems>
        <Dropdown.Item isEdit name="edit" onClick={() => selectShadow(shadow)} />
        <Dropdown.Item icon={faTag} label="Rename" name="rename" onClick={() => setShow(true)} />
        <Dropdown.Item icon={faCopy} label="Duplicate" name="duplicate" onClick={() => duplicateShadow(shadow)} />
        {showDownload ? (
          <Dropdown.ParentItem icon={faDownload} key="download" label="Download" name="download">
            <Dropdown.Item icon={faFileExcel} label="Excel" name="excel" onClick={() => handleExport(false)} />
            <Dropdown.Item icon={faFileCsv} label="CSV" name="csv" onClick={() => handleExport(true)} />
          </Dropdown.ParentItem>
        ) : []}
        <Dropdown.Item isDelete name="delete" onClick={confirmDeletion} />
      </Dropdown.MenuItems>
    </Dropdown>
    {
      show && (
        <RenameModal
          shadow={shadow}
          onClose={() => setShow(false)}
          onRename={handleRename}
        />
      )
    }
  </>;
}

ShadowRowActions.propTypes = {
  canExportShadows: PropTypes.bool,
  deleteShadow: PropTypes.func.isRequired,
  duplicateShadow: PropTypes.func.isRequired,
  exportShadow: PropTypes.func.isRequired,
  selectShadow: PropTypes.func.isRequired,
  shadow: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  updateShadow: PropTypes.func.isRequired,
};

const mapStateToProps = ({ canExportShadows }) => ({
  canExportShadows
});

const mapDispatchToProps = {
  deleteShadow,
  duplicateShadow,
  exportShadow,
  selectShadow,
  updateShadow,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShadowRowActions);
